import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/global.scss'

// 注册全局组件
import '@/plugins/components'

// 注册权限指令
import permissionDirective from '@/directives/permission'

// 从本地存储加载权限到Vuex
import { loadPermissionsFromStorage } from '@/utils/storage-permission'

Vue.config.productionTip = false

// 创建事件总线
Vue.prototype.$bus = new Vue()

Vue.use(ElementUI, { locale })
Vue.use(permissionDirective)

// 应用启动时自动加载权限到Vuex
// 确保在Vue实例创建之前就加载权限数据
loadPermissionsFromStorage()

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 在Vue实例创建后再次确保权限数据已加载
    this.$nextTick(() => {
      const permissions = loadPermissionsFromStorage()
    })
  }
}).$mount('#app')
